module.exports = __webpack_public_path__ + "media/images/filter-icon-4dce1cd9234a6cc9be89dfd94385a716.png";